// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import React from "react"
import { classNames } from "@plasmicapp/react-web"

export function Ellipse59Icon(props) {
  const { className, style, title, ...restProps } = props
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 1306 875"}
      height={"1em"}
      width={"1em"}
      style={{
        stroke: "currentcolor",
        ...(style || {}),
      }}
      className={classNames("plasmic-default__svg", className)}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        d={
          "M1304.42 437.387c0 120.345-72.79 229.417-190.73 308.449-117.931 79.027-280.909 127.938-460.979 127.938s-343.048-48.911-460.98-127.938C73.793 666.804 1 557.732 1 437.387S73.793 207.97 191.731 128.938C309.663 49.912 472.641 1 652.711 1s343.048 48.912 460.979 127.938c117.94 79.032 190.73 188.104 190.73 308.449z"
        }
        stroke={"currentColor"}
        strokeWidth={"2"}
      ></path>
    </svg>
  )
}

export default Ellipse59Icon
/* prettier-ignore-end */
